import api from 'utils/api';
import { objectToQueryString } from 'utils/helpers';

const servicePath = '/paid-services';

export const getAll = async (params) => {
  try {
    const query = objectToQueryString(params);
    const response = await api.get(`${servicePath}${query ? '?' + query : ''}`);
    const records = response.data;

    return records;
  } catch (err) {
    console.log(err);
  }
}

export const getOne = async (id) => {
  try {
    const response = await api.get(`${servicePath}/${id}`);
    const records = response.data;

    return records;
  } catch (err) {
    console.log(err);
  }
}

export const create = async (details) => {
  try {
    const response = await api.post(servicePath, details);
    const record = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}

export const update = async (id, details) => {
  try {
    const response = await api.put(`${servicePath}/${id}`, details);
    const record = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}

export const remove = async (id) => {
  try {
    const response = await api.delete(`${servicePath}/${id}`);
    const record = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}